import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";
import RewardsService from "../../../../services/reward";
import { useDispatch, useSelector } from "react-redux";
import Utils from "../../../../utility";
import {
  hideLoader,
  removeUser,
  showLoader
} from "../../../../slices/userSlice";
import CustomPagination from "../../../../common/components/customPagination";
import { keyConstants } from "../../../../constants";

function CouponInventory() {
  const [couponData, setCouponData] = useState([]);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const itemsPerPage = 10; // page limit
  const [totalItems, setTotalItems] = useState(0);
  const [isAscending, setIsAscending] = useState(true); //sortingKey addedOn

  const { IS_REFRESH_TOKEN_LOADING } = keyConstants;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const fetchCouponData = async (skip, limit) => {
    const tokenStatus = await Utils.checkTokenExpireOrNot(fetchCouponData);
    if (tokenStatus) {
      if (tokenStatus === IS_REFRESH_TOKEN_LOADING) return;
      dispatch(removeUser({}));
      return;
    }
    try {
      dispatch(showLoader());
      const business = user._id;
      const rewardsService = new RewardsService();
      const response = await rewardsService.getUserCoupon({
        business,
        sortingKey: isAscending ? "addedOn" : "-addedOn",
        skip,
        limit
      });
      setCouponData(response?.data);
      setTotalItems(response?.total);
    } catch (error) {
      console.error(error);
      return;
    } finally {
      dispatch(hideLoader());
    }
  };
  useEffect(() => {
    fetchCouponData((page - 1) * itemsPerPage, itemsPerPage);
  }, [page, isAscending]);

  return (
    <div className="mb-20 mt-5 flex w-full flex-col px-4 md:px-12.5">
      <p className="font-PoppinsSemiBold text-ft22-26.82-0.4 text-black-131426">
        Coupons Allocation
      </p>
      <div className="mt-1">
        <p className="font-PoppinsRegular text-ft15-22.5-0.3 text-grey-575757">
          See how your created coupon are allocated to the users
        </p>
      </div>

      {couponData?.length !== 0 ? (
        <div
          style={{ scrollbarWidth: "thin" }}
          className="relative mt-7.5 overflow-auto rounded border border-grey-D9D9D9"
        >
          <table className="w-full border-grey-D9D9D9 text-left">
            <thead className="border-none border-b-grey-D9D9D9">
              <tr className="whitespace-nowrap pl-15px pt-3 font-MontserratSemiBold text-ft16-19.5 text-black-000000">
                <th scope="col" className="pb-2.5 pl-15px pt-3">
                  Coupon ID
                </th>
                <th scope="col" className="pb-2.5 pl-3 pt-3">
                  Public ID
                </th>
                <th scope="col" className="pb-2.5 pl-3 pt-3">
                  Discount Code
                </th>
                <th scope="col" className="pb-2.5 pl-3 pt-3">
                  Discount Value
                </th>
                <th scope="col" className="pb-2.5 pl-3 pt-3">
                  <div className="flex flex-row gap-2">
                    <div>
                      <p className="font-MontserratSemiBold text-ft16-19.5">
                        Received On
                      </p>
                    </div>
                    <div>
                      <FaArrowUp
                        className={`h-5 w-13px cursor-pointer text-purple-6C36B0 duration-100 ${
                          isAscending ? "" : "-rotate-180" // Add rotation class conditionally
                        }`}
                        onClick={() => setIsAscending(!isAscending)}
                      />
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {couponData?.map((item) => (
                <tr
                  key={item._id}
                  className="whitespace-nowrap border-t border-grey-D9D9D9 bg-white font-PoppinsRegular text-ft15-26.25 text-black-000000 "
                >
                  <td className="py-11px pl-15px">{item?._id}</td>
                  <td className="py-11px pl-3">
                    {Utils.truncateWalletAddress(
                      item?.providedConsent?.walletAddress
                    )}
                  </td>
                  <td className="py-11px pl-3">
                    {item?.couponCode?.code || "-"}
                  </td>
                  <td className="py-11px pl-3">
                    {item?.couponData?.discountValue}
                  </td>
                  <td className="py-11px pl-3">
                    {Utils.formatTimestamp(item?.updatedOn)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div
          style={{ height: window.innerHeight - 198 }} // Managing height here using window.innerHeight
          className="mt-8 grid w-full place-items-center rounded border border-solid border-grey-D9D9D9"
        >
          <div className="flex flex-col items-center gap-9">
            <img
              src="/images/no-coupon-allocated.svg"
              alt="No Coupon Allocated "
            />
            <div className="font-PoppinsMedium text-ft22-33-0.4 text-grey-767676">
              No Coupon Allocated Yet
            </div>
          </div>
        </div>
      )}

      {totalItems > itemsPerPage && (
        <CustomPagination
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          currentPage={page}
          handleChangePage={handleChangePage}
        />
      )}
    </div>
  );
}

export default CouponInventory;
